import { Component, Renderer2, AfterViewInit, HostListener, OnDestroy } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { BnNgIdleService } from 'bn-ng-idle';
import { MenuService } from './service/MenuService';
import { Router, NavigationEnd } from '@angular/router';
import { UserService } from './service/UserService';
import { environment } from 'src/environments/environment';
import { Subscription } from 'rxjs';
import { filter } from 'rxjs/operators';
import { ContactUsService } from './service/ContactUsService';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html'
})

export class AppComponent implements AfterViewInit, OnDestroy {
  title = 'BpsSelfServiceAngular';
  currentLang = "en";
  resourceUrlSubscription: Subscription;
  showLandingContent:boolean = false;
  private bnIdleSubscription: Subscription;

  constructor(private renderer: Renderer2, public translate: TranslateService, private bnIdle: BnNgIdleService, public menuService: MenuService, private router: Router, public rest: UserService,
    public contactService: ContactUsService) {
    translate.addLangs(['en', 'fr']);
    translate.setDefaultLang('en');

    this.currentLang = (sessionStorage.getItem("currentLang") === 'fr') ? 'fr' : 'en';
    translate.use(this.currentLang);
  }  

  ngOnInit(): void {
    this.router.events.pipe(filter(event => event instanceof NavigationEnd)).subscribe(() => {
      const currentUrl = this.router.url;
      console.log('current URL:', currentUrl);

      //if it's not sessionTimeout/logout page, start idle watcher for inactive 15 mins
      if (currentUrl !== '/public/sessionTimeout' && currentUrl !== '/public/logout' && currentUrl !== '/public/logoutSuccess') {
        this.bnIdleSubscription = this.bnIdle.startWatching(900).subscribe((res) => {
          if (res) {
            console.log('session expired');
            this.stopWatching();

            //wait 1 second here so I can watch the console log
            setTimeout(() => {
              window.location.href = "/opsbpssecure/public/sessionTimeout";
            }, 1000);
          }
        });
      } 
    });

    if (sessionStorage.getItem('restrictedEmailDomains') == null) {
      this.rest.getRestrictedEmailDomains().subscribe(response => {
        console.log("getRestrictedEmailDomains:" + JSON.stringify(response));
        if (response['result'] > 0) {
          console.log("getRestrictedEmailDomains result: " + response['result']);
          sessionStorage.setItem("restrictedEmailDomains", "null");
        } else {
          sessionStorage.setItem("restrictedEmailDomains", response['domains']);
        }
      }, (error) => { console.log("getRestrictedEmailDomains failed") });
    }

    this.translate.onLangChange.subscribe((event) => {
      this.renderer.setAttribute(document.documentElement, 'lang', event.lang);
    });    
  } 

  public get isCurrentEn(): boolean {
    return this.translate.currentLang === 'en';
  }  

  public get isProduction(): boolean {
    return environment.production;
  }

  public onSwitchLang() {
    this.currentLang = (this.currentLang === 'en') ? 'fr' : 'en';
    this.translate.use(this.currentLang);
    sessionStorage.setItem("currentLang", this.currentLang);
  }

  ngAfterViewInit(): void {
    function loadScriptAsync(src: string) {
      return new Promise((resolve, reject) => {
        const ad11yScript = document.createElement('script');
        ad11yScript.type = 'text/javascript';
        ad11yScript.src = src;
        ad11yScript.onload = resolve;
        ad11yScript.onerror = reject;
        document.body.appendChild(ad11yScript);
      });
    }
    
    // Usage
    loadScriptAsync('assets/scripts/ontario-a11y.js')
      .then(() => {
        const ohScript = this.renderer.createElement('script');
        ohScript.type = 'text/javascript';
        ohScript.src = 'assets/scripts/ontario-header.js';
        this.renderer.appendChild(document.body, ohScript);

        const oecScript = this.renderer.createElement('script');
        oecScript.type = 'text/javascript';
        oecScript.src = 'assets/scripts/ontario-expand-collapse.js';
        this.renderer.appendChild(document.body, oecScript);
      })
      .catch((error) => {
        console.error('Error loading script: ontario-a11y.js', error);
        this.router.navigate([this.router.url]);
      });

    // const bpsScript = this.renderer.createElement('script');
    // bpsScript.type = 'text/javascript';
    // bpsScript.src = 'assets/scripts/bpsss.js';
    // this.renderer.appendChild(document.body, bpsScript);

  }  

  openContactUsPopup(event) {
    event.preventDefault();
  }

  onHelp() {
    const helpLink = '/public/help?id=' + encodeURIComponent(this.router.url);
    this.router.navigateByUrl(helpLink);
  }

  //EBSE Fix: if user leave the page, stop idleService watching
  @HostListener('window:beforeunload', ['$event'])
  @HostListener('window:unload', ['$event'])
  handleWindowClose(event: Event) {
    this.stopWatching();
  }

  ngOnDestroy() {
    this.stopWatching();
  }

  private stopWatching() {
    console.log("stop watching");
    if (this.bnIdleSubscription) {
      console.log("unsubscribe");
      this.bnIdleSubscription.unsubscribe();
    }
  }  
}
